import type { RoleFormDialogProps } from "./types-role-form-dialog";
import { useRoleFormDialog } from "./use-role-form-dialog";
import { RoleFormDialogView } from "./view-role-form-dialog";

/** Modal Novo/Editar perfil (HU 864, Figma 4434:111717 e 4987:43761). */
export function RoleFormDialog(props: RoleFormDialogProps) {
  const vm = useRoleFormDialog(props);

  return <RoleFormDialogView {...vm} />;
}

export type * from "./types-role-form-dialog";
